export default __webpack_public_path__ + "static/media/workouttimes_7.d8a67e1e.jpg";